import { useEffect, useState } from "react";
import {
  Button,
  MenuItem,
  Grid,
  InputLabel,
  FormControl,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Select from "@mui/material/Select";
import Iconify from "../iconify";
import AssetsDialog from "./AssetsDialog";
import { FormGroup } from "@mui/material";

const defaultState = {
  icon: "",
  has_prizing_image: false,
  is_private: false,
  prize: false,
};
export default function LeagueDialog(props) {
  const [league, setLeague] = useState(props.league || defaultState);
  const [assetsTarget, setAssetsTarget] = useState(null);

  useEffect(() => {
    if (props.league !== null) {
      setLeague(props.league);
    }
  }, [props]);
  const handleChange = (e) => {
    const { id, value } = e.target;
    setLeague((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const onSuccess = () => {
    setLeague(defaultState);
    props.onSuccessHandler(league);
  };
  const onCancel = () => {
    setLeague(defaultState);
    props.onClose();
  };
  const onChoseAsset = (assetUrl) => {
    setLeague((prevState) => ({
      ...prevState,
      [assetsTarget]: assetUrl,
    }));
    setAssetsTarget(null);
  };
  const onCloseAssetsDialog = (assetUrl) => {
    setAssetsTarget(null);
  };
  const handleChangetype = (event) => {
    setLeague((prevState) => ({
      ...prevState,
      type: event.target.value,
    }));
  };

  return (
    <>
      {assetsTarget === null ? (
        <Dialog
          open={props.open}
          onClose={() => {}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {props.league === null ? "Create" : "Edit"} Custom League
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id="name"
                  label="Name"
                  fullWidth
                  value={league.name}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="sponsor_slug"
                  label="Sponsor slug"
                  fullWidth
                  value={league.sponsor_slug}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="vanity_slug"
                  label="Vanity slug"
                  fullWidth
                  value={league.vanity_slug}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="passcode"
                  label="Passcode"
                  fullWidth
                  value={league.passcode}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="type-select-label">Type</InputLabel>
                  <Select
                    labelId="type-label"
                    id="type-select"
                    value={league.type}
                    label="Type"
                    onChange={handleChangetype}
                  >
                    <MenuItem value="CLUB">CLUB</MenuItem>
                    <MenuItem value="FRIENDS">FRIENDS</MenuItem>
                    <MenuItem value="OFFICIAL">OFFICIAL</MenuItem>
                    <MenuItem value="PARTNER">PARTNER</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="has_prizing_image"
                        checked={
                          league.has_prizing_image === "true" ||
                          league.has_prizing_image === true
                        }
                        onChange={(e) => {
                          setLeague((prevState) => ({
                            ...prevState,
                            [e.target.id]: e.target.checked,
                          }));
                        }}
                      />
                    }
                    label="Has prizing image"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="is_private"
                        checked={
                          league.is_private === "true" ||
                          league.is_private === true
                        }
                        onChange={(e) => {
                          setLeague((prevState) => ({
                            ...prevState,
                            [e.target.id]: e.target.checked,
                          }));
                        }}
                      />
                    }
                    label="Is private"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="prize"
                        checked={
                          league.prize === "true" || league.prize === true
                        }
                        onChange={(e) => {
                          setLeague((prevState) => ({
                            ...prevState,
                            [e.target.id]: e.target.checked,
                          }));
                        }}
                      />
                    }
                    label="Prize"
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={6}>
                <Box>Image</Box>
                {league.league_image_en ? (
                  <>
                    <img
                      style={{
                        margin: "0 auto",
                        width: 100,
                        background: "grey",
                      }}
                      alt="Remy Sharp"
                      src={league.league_image_en}
                    />
                    <Iconify
                      icon="eva:edit-outline"
                      sx={{ width: 20, height: 20, cursor: "pointer" }}
                      onClick={() => setAssetsTarget("league_image_en")}
                    />
                  </>
                ) : (
                  <Iconify
                    icon="eva:plus-circle-outline"
                    sx={{
                      width: 20,
                      height: 20,
                      cursor: "pointer",
                      marginTop: 2,
                      marginBottom: 2,
                    }}
                    onClick={() => setAssetsTarget("league_image_en")}
                  />
                )}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCancel()}>Cancel</Button>
            <Button
              onClick={() => onSuccess()}
              autoFocus
              disabled={
                !league.name ||
                !league.type ||
                !league.vanity_slug ||
                !league.sponsor_slug
              }
            >
              {props.league === null ? "Create" : "Edit"}
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <AssetsDialog onSuccess={onChoseAsset} onClose={onCloseAssetsDialog} />
      )}
    </>
  );
}
